import { request } from '@/shared/api/request'
export const getRequestsAdjustment = () => {
	return request({ url: 'contract/labor/jur/getRequestsAdjustmentData', method: 'GET' })
}
